// extracted by mini-css-extract-plugin
export default {"tags":"ArticleTags_tags__Vt4Y1","label":"ArticleTags_label__GAwS5","list":"ArticleTags_list__nRGf0","item":"ArticleTags_item__GtgQh"};